module.exports = __webpack_public_path__ + "static/media/bell-dot.ccad6209.svg";